module.exports = __webpack_public_path__ + "static/media/arrow-triangle-fill-up.88962aca.svg";